import { render, staticRenderFns } from "./Element.vue?vue&type=template&id=83ef1a08"
import script from "./Element.vue?vue&type=script&lang=js"
export * from "./Element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83ef1a08')) {
      api.createRecord('83ef1a08', component.options)
    } else {
      api.reload('83ef1a08', component.options)
    }
    module.hot.accept("./Element.vue?vue&type=template&id=83ef1a08", function () {
      api.rerender('83ef1a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Element.vue"
export default component.exports